import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { LiaUserSecretSolid } from "react-icons/lia";
import { useInView } from "react-intersection-observer";

export default function CustomerReviews() {
  const [reviews, setReviews] = useState([]);
  const [businessData, setBusinessData] = useState({});
  const hasFetched = useRef(false);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const fetchReviews = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_APIBASE_URL}/payslips/google-reviews`,
      );

      const data = await response.json();

      if (data?.success) {
        setReviews(data.reviews || []);

        setBusinessData({
          businessName: data.businessName,
          rating: data.rating,
          totalReviews: data.totalReviews,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") return;

    if (inView) {
      if (hasFetched.current) return;

      hasFetched.current = true;
      fetchReviews();
    }
  }, [inView]);
  const getGoogleAvatar = (url) => {
    if (!url) return null;

    // Replace any existing Google size parameter
    return url.replace(/=s\d+.*$/, "=s92-c");
  };
  return (
    <section className="bg-[#f4f7fb] py-10 px-6" ref={ref}>
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <h2 className="text-center text-xl md:text-3xl font-bold text-[#17324d] uppercase tracking-wide">
          What Our Customers Say
        </h2>
        <p className="text-center text-[#10324F] text-lg mt-4 font-normal  font-roboto">
          Businesses across India trust Waggex to get payroll right every month,
          without fail.
        </p>
        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {/* Top 3 Highest Rated Reviews */}
          {reviews
            .filter((item) => item.text?.trim() && item.text.trim().length > 50)
            .sort((a, b) => b.rating - a.rating) // highest rating first
            .slice(0, 3) // top 3
            .map((item, index) => (
              <div
                key={index}
                className="rounded-xl bg-[#F6F9FB] p-6 border-0 overflow-hidden transition-transform duration-300 backdrop-blur-[10px] shadow-[-20px_-20px_30px_0_#D1DFEA4D,-15px_-15px_20px_0_#D1DFEA66_inset] hover:shadow-[0_4px_4px_0_#D1DFEA6B,-3px_-3px_10px_0_#D1DFEA_inset]"
              >
                {/* Quote Icon */}
                <div className="mb-4">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    width="42"
                    height="32"
                    viewBox="0 0 42 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-[#D1DFEA]"
                  >
                    <path
                      d="M18.4 0C8.8 4.8 3.2 12 3.2 20.8C3.2 27.2 7.2 32 13.6 32C18.4 32 22.4 28.4 22.4 23.2C22.4 18.4 18.8 15.2 14 15.2C13.2 15.2 12.4 15.2 11.6 15.6C12.4 10.8 15.6 6.8 20.8 3.6L18.4 0ZM39.2 0C29.6 4.8 24 12 24 20.8C24 27.2 28 32 34.4 32C39.2 32 42 28.4 42 23.2C42 18.4 38.4 15.2 33.6 15.2C32.8 15.2 32 15.2 31.2 15.6C32 10.8 35.2 6.8 40.4 3.6L39.2 0Z"
                      fill="currentColor"
                      fillOpacity="0.7"
                    />
                  </svg>
                </div>

                {/* Review Text */}
                <p className="service-list-item-text mb-6 min-h-30">
                  {item.text}
                </p>

                {/* Footer */}
                <div className="flex items-center gap-3">
                  {/* Avatar */}
                  <div className="rounded-full overflow-hidden border border-[#D1DFEA]">                   
                    <LiaUserSecretSolid
                      size={40}
                      color="#10324F"
                      className="text-center"
                    />
                  </div>

                  <div>
                    <h2 className="text-xs font-semibold text-[#10324F]">
                      {item.author_name}
                    </h2>

                    <div className="flex text-yellow-400 text-sm mt-1">
                      {"★".repeat(item.rating)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
